import {Component} from 'preact';
import cx from 'classnames';
import Icon from '@components/common/Icon';
import {Cart} from '@modules/cart/Cart';
import QtyToggle from '@components/common/QtyToggle';
import CartService from '@services/CartService';
import debounce from 'lodash.debounce';
import {calculateMaxInputQuantityForProduct} from '@modules/products/util';

class AddCartButton extends Component {

    constructor ( props ) {
        super( props );

        this.onUpdateItem = debounce( this.onUpdateItem.bind( this ), 1000 );
        this.onAddItem = this.onAddItem.bind( this );
        this.onCartChange = this.onCartChange.bind( this );

        this.state = {
            processingAdd: false
        };
    }

    async componentDidMount () {
        Cart.bind( 'cartChange', this.onCartChange );
        this.setMaxQuantity( {
            product: this.props.product
        } );
    }

    async componentWillReceiveProps ( nextProps, nextContext ) {
        this.setMaxQuantity( {product: nextProps.product} );
    }

    async onCartChange ( e, cart ) {
        if ( cart.product.sku === this.props.product.sku ) {
            this.setMaxQuantity( {
                product: this.props.product,
                inCartQuantity: cart.quantity
            } );
        }
    }

    componentWillUnmount () {
        Cart.unbind( 'cartChange', this.onCartChange );
    }

    async setMaxQuantity ( {product, inCartQuantity = null} ) {
        const cartState = await calculateMaxInputQuantityForProduct( {product, inCartQuantity} );
        this.setState( {...cartState} );
    }

    async onUpdateItem ( quantity ) {
        const {product} = this.props;

        if ( quantity <= 0 ) {
            await CartService.deleteLineItems( {product} );
            return;
        }

        await CartService.updateLineItems( {product, quantity} );
    }

    async onAddItem () {
        const {product} = this.props;

        this.setState( {processingAdd: true} );
        await CartService.addLineItems( [{product, quantity: 1}] );
        this.setState( {processingAdd: false} );
    }

    renderActionComponent () {
        const {product, className, ...rest} = this.props;
        const {inCartQuantity, maxInputQuantity, processingAdd} = this.state;
        const lineQty = processingAdd ? 1 : parseInt( inCartQuantity );

        if ( lineQty > 0 ) {
            return (
                <QtyToggle
                    className={className}
                    value={lineQty}
                    min={0}
                    max={maxInputQuantity}
                    onChange={this.onUpdateItem}/>
            );
        }

        const btnClassName = cx( 'button w-full', className );

        return (
            <a data-sku={product.sku} className={btnClassName} onClick={this.onAddItem} {...rest}>
                <Icon.ui name="shopping-cart-add" className="text-xl mr-2"/>
                Add To Cart
            </a>
        );
    }

    render ( props ) {
        const {maxQuantityExceeded, maxQuantity} = this.state;

        return (
            <div className="w-full">
                {this.renderActionComponent()}
                {maxQuantityExceeded &&
                <p className="font-bold text-warning text-sm my-2">
                    <Icon.ui name="report-problem-triangle" className="text-sm mr-1"/>
                    {maxQuantity <= 0
                        ? `This item is not currently available for online orders.`
                        : `This item is limited to ${maxQuantity} per customer.`
                    }
                </p>
                }
            </div>
        );
    }
}

export default AddCartButton;
